import { t } from "i18next";
import CoreButtonHoverIcon from "../../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import CardTask from "./Card/CardTask";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import TaskBarChart from "./Chart/TaskBarChart";
import TaskPieChart from "./Chart/TaskPieChart";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import { useEffect, useState } from "react";
import {
  useGetTaskBarActivityQuery,
  useGetTaskBarEffortQuery,
  useGetTaskBarOperativeCapacityQuery,
  useGetTaskCardStatsQuery,
  useGetTaskPieOpenPendingQuery,
  useGetTaskPieServiceQuery,
  useGetTaskPieStatusQuery,
  useLazyDoDownloadTaskStatsQuery,
} from "../../../api/admin/dashboardApi";
import { toast } from "react-toastify";
import TaskLineChart from "./Chart/TaskLineChart";
import { useSelector } from "react-redux";

const ActivityView = ({ filter, tab }) => {
  const appConfig = useSelector((state) => state.app.appConfig);

  const [value, setValue] = useState(0);
  const [labelChart, setLabelChart] = useState("Stato Attività");
  const [card, setCard] = useState(Array(6).fill({}));
  const [barActivity, setBarActivity] = useState();
  const [barCapacity, setBarCapacity] = useState();
  const [barEffort, setBarEffort] = useState();
  const [pieService, setPieService] = useState();
  const [pieOpenPending, setPieOpenPending] = useState();
  const [pieStatus, setPieStatus] = useState();

  const { data: dataCard, isLoading: isLoadingCard } =
    useGetTaskCardStatsQuery(filter);

  const { data: dataBarActivity } = useGetTaskBarActivityQuery(filter, {
    skip: !tab,
  });
  const { data: dataBarCapacity } = useGetTaskBarOperativeCapacityQuery(
    filter,
    { skip: !tab }
  );
  const { data: dataBarEffort } = useGetTaskBarEffortQuery(filter, {
    skip: !tab,
  });
  const { data: dataPieService } = useGetTaskPieServiceQuery(filter, {
    skip: !tab,
  });

  const { data: dataPieOpenPending } = useGetTaskPieOpenPendingQuery(filter, {
    skip: !tab,
  });
  const { data: dataPieStatus } = useGetTaskPieStatusQuery(filter, {
    skip: !tab,
  });

  const [doDownloadTask] = useLazyDoDownloadTaskStatsQuery();

  useEffect(() => {
    if (dataCard && dataCard.Data) {
      setCard(dataCard.Data);
    }
  }, [dataCard]);

  useEffect(() => {
    if (dataBarActivity && dataBarActivity.Data) {
      setBarActivity(dataBarActivity.Data);
    }
  }, [dataBarActivity]);
  useEffect(() => {
    if (dataBarCapacity && dataBarCapacity.Data) {
      setBarCapacity(dataBarCapacity.Data);
    }
  }, [dataBarCapacity]);
  useEffect(() => {
    if (dataBarEffort && dataBarEffort.Data) {
      setBarEffort(dataBarEffort.Data);
    }
  }, [dataBarEffort]);

  useEffect(() => {
    if (dataPieService && dataPieService.Data) {
      setPieService(dataPieService.Data);
    }
  }, [dataPieService]);
  useEffect(() => {
    if (dataPieOpenPending && dataPieOpenPending.Data) {
      setPieOpenPending(dataPieOpenPending.Data);
    }
  }, [dataPieOpenPending]);
  useEffect(() => {
    if (dataPieStatus && dataPieStatus.Data) {
      setPieStatus(dataPieStatus.Data);
    }
  }, [dataPieStatus]);

  const getChartData = (value) => {
    if (value === 1) {
      return { dataBar: barCapacity, dataPie: pieOpenPending };
    }
    if (value === 2) {
      return { dataBar: barEffort, dataPie: pieStatus };
    }
    return { dataBar: barActivity, dataPie: pieService };
  };

  const { dataBar, dataPie } = getChartData(value);

  const handleChangeChart = (value, label) => {
    setValue(value);
    setLabelChart(label);
  };

  const excelRequest = () =>
    new Promise((resolve, reject) => {
      doDownloadTask(filter)
        .then((res) => {
          if (res.isError || !res.data) throw new Error("Download fallito");

          const url = window.URL.createObjectURL(res.data);
          const a = document.createElement("a");
          a.href = url;
          a.download = "task-dashboard.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);

          resolve();
        })
        .catch(() => reject());
    });

  const handleDownloadExcel = () => {
    toast.promise(
      excelRequest,
      {
        pending: {
          render: t("HandleDownload"),
          type: "info",
        },
        success: t("FileReady"),
        error: t("ReqErr"),
      },
      { autoClose: 1500 }
    );
  };

  return (
    <div>
      <CoreButtonHoverIcon
        className="text-blue-600 m-1"
        onClick={handleDownloadExcel}
        testo={t("Download")}
        icon={<DownloadRoundedIcon />}
      />
      <CardTask card={card} loading={isLoadingCard} />
      <div>
        <div className="grid grid-cols-12 gap-2 m-4 py-8 p-3 shadow-md rounded-lg">
          <div className="col-span-9">
            {value === 2 ? (
              <TaskLineChart dataBar={dataBar} labelChart={labelChart} />
            ) : (
              <TaskBarChart dataBar={dataBar} labelChart={labelChart} />
            )}
          </div>
          <div className="col-span-3">
            <TaskPieChart dataPie={dataPie} labelChart={labelChart} />
          </div>
        </div>
        <div className="flex justify-center space-x-3">
          <CoreButton
            variant="outlined"
            testo="Stato Attività"
            className="text-blue-600 border-blue-600 border-2"
            onClick={() => handleChangeChart(0, "Stato Attività")}
          />
          <CoreButton
            variant="outlined"
            testo="Capacità Operativa"
            className="text-blue-600 border-blue-600 border-2"
            onClick={() => handleChangeChart(1, "Capacità Operativa")}
          />
          {appConfig?.modules?.practice?.subtask && (
            <CoreButton
              variant="outlined"
              testo="Analisi Effort"
              className="text-blue-600 border-blue-600 border-2"
              onClick={() => handleChangeChart(2, "Analisi Effort")}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityView;
